var CompanySize = {
	"Company size": "Firmengröße",
	"1-19 employees": "1–19 Mitarbeiter",
	"20-99 employees": "20 – 99 Mitarbeiter",
	"100-499 employees": "100 – 499 Mitarbeiter",
	"500-999 employees": "500 – 999 Mitarbeiter",
	"1,000-9,999 employees": "1 000 – 9 999 Mitarbeiter",
	"10,000 employees or more": "10 000 Mitarbeiter oder mehr"
};

export { CompanySize as default };
